/**
 * The upsell modal's dynamic-import boundary, in its own module so specs can
 * mock it.
 *
 * Native `import()` throws under jest, and `show_bulk_download_modal` catches a
 * failed load (correctly — a broken chunk must not strand the visitor's paper).
 * Together those mean a spec that exercises the flow sees the modal silently
 * never render, and anything asserted after the modal closes passes for the
 * wrong reason. `js/autofake/loadAutofakeFlow` exists for exactly this reason;
 * this is the same move for the surface it interposes on.
 *
 * The import is byte-identical to the one it replaces — no `webpackChunkName`,
 * so chunk naming and the async boundary are unchanged. A one-line wrapper
 * earns its name here as a test seam, which is the one thing it exists to be.
 */
export function loadUpsellModal() {
  return import('./WorkCardsBulkDownloadUpsellModal');
}
